import React from "react";

type WalletSuccessModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onGoToWallet: () => void;
  // Echoed back from createWallet's response as a final confirmation of the
  // same BVN name shown during verification.
  bvnName?: string | null;
};

const WalletSuccessModal: React.FC<WalletSuccessModalProps> = ({
  isOpen,
  onClose,
  onGoToWallet,
  bvnName,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full mx-4 relative">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        {/* Success content box with dashed border */}
        <div className="border-2 border-dashed border-green-300 bg-green-50 rounded-xl p-8 text-center">
          {/* Celebration icon */}
          <div className="mb-4 flex justify-center">
            <div className="text-6xl">🎉</div>
          </div>

          {/* Title */}
          <h2 className="text-xl font-bold text-[#13532E] mb-3">
            Wallet Setup Complete!
          </h2>

          {/* Description */}
          <p className="text-[#166035] text-sm mb-3">
            You can now start sending money, topping up your wallet, and
            receiving payments securely.
          </p>

          {bvnName && (
            <p className="text-[#166035] text-xs mb-4 bg-white/60 border border-green-200 rounded-lg px-3 py-2 inline-block">
              Verified BVN name: <span className="font-semibold">{bvnName}</span>
            </p>
          )}

          {/* Go to Wallet button */}
          <button
            onClick={onGoToWallet}
            className="bg-white text-[#166035] px-6 py-2 rounded-lg border border-[#166035]  transition-colors inline-flex items-center justify-center gap-2"
          >
            Go to Wallet overview
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className="w-5 h-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default WalletSuccessModal;